import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import type { ReactNode } from 'react';

import styles from './AppHeader.module.scss';

const appLabel = <span className='text-size-18 text-bold text-uppercase white-space-nowrap'>Shelter</span>;

export type AppHeaderProps = {
    /** Header actions such as the user menu. Omitted on pages without an authenticated user. */
    actionBarItems?: ReactNode[];
};

/** The application header, shared by every page so the application name stays visible. */
const AppHeader = ({ actionBarItems }: AppHeaderProps) => (
    <ApplicationHeader label={appLabel} className={styles.applicationHeader} actionBarItems={actionBarItems} />
);

export default AppHeader;
